import { ReactElement } from 'react';
import { InstanceType } from 'types/enums/instance';
import { Navigate } from 'react-router-dom';
import { APP_DEFAULT_PATH, INSTANCE_TYPE } from 'config';

type InstanceGuardProps = {
    children: ReactElement | null;
    allowed?: InstanceType[];
    disallowed?: InstanceType[];
};

const InstanceGuard = ({ children, allowed, disallowed }: InstanceGuardProps) => {
    const currentInstance = INSTANCE_TYPE;

    if (allowed && !allowed.includes(currentInstance)) {
        return <Navigate to={APP_DEFAULT_PATH} replace />;
    }

    if (disallowed && disallowed.includes(currentInstance)) {
        return <Navigate to={APP_DEFAULT_PATH} replace />;
    }

    return children;
};

export const InstanceFeature = ({ children, allowed, disallowed }: InstanceGuardProps) => {
    const currentInstance = INSTANCE_TYPE;

    if (allowed && !allowed.includes(currentInstance)) {
        return null;
    }

    if (disallowed && disallowed.includes(currentInstance)) {
        return null;
    }

    return <>{children}</>;
};

export default InstanceGuard;
